export default "__VITE_ASSET__b7be0837__"